export default __webpack_public_path__ + "static/media/contact-us.47f3f299.png";